/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const changeMonthlyPaymentPostRequestSchema = z.object({
  recommended_payment: z.string(),
  reference: z.string(),
});
